import { render, staticRenderFns } from "./AIStarsSvg.vue?vue&type=template&id=2dd279c0&"
import script from "./AIStarsSvg.vue?vue&type=script&lang=js&"
export * from "./AIStarsSvg.vue?vue&type=script&lang=js&"
import style0 from "./AIStarsSvg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports